// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "main.3ae34d52.css";
	// return url for filenames based on template
	return "" + chunkId + "." + "8faf843e" + ".chunk.css";
};